import { useMemo } from "react";
import styled from "styled-components";
import { SP_BREAKPOINT } from "../../../constants/app";
import { PRIMARY_LIGHT_GREEN } from "../../../constants/color";
import { Button } from "../../atoms/Button";
import { LoadingIcon } from "../../atoms/icons/LoadingIcon";

type Props = {
  fileName: string;
  fileSize: string;
  templateName: string;
  isUploading: boolean;
  onCancel: () => void;
  onUpload: () => void;
};

export const FileResultSP: React.FC<Props> = ({
  fileName,
  fileSize,
  templateName,
  isUploading,
  onCancel,
  onUpload,
}) => {
  const fileResult = useMemo(() => {
    return {
      ファイル名: fileName,
      サイズ: fileSize,
      テンプレート: templateName,
      ステータス: isUploading ? "転送中" : "アップロード可能",
    };
  }, [fileName, fileSize, templateName, isUploading]);

  return (
    <StyledBackground>
      <StyledFileUploadContainer>
        <StyledTitle>アップロードファイル</StyledTitle>

        <StyledFileUploadResult>
          <StyledFileUploadResultDetail>
            {Object.entries(fileResult).map(([key, value]) => (
              <StyledResultDetailRow key={key}>
                <StyledResultTitle>{key}</StyledResultTitle>
                <StyledResultValue>
                  {value}

                  {key === "ステータス" && isUploading && <LoadingIcon />}
                </StyledResultValue>
              </StyledResultDetailRow>
            ))}
          </StyledFileUploadResultDetail>
        </StyledFileUploadResult>
      </StyledFileUploadContainer>

      <StyledFooter>
        <Button text="キャンセル" variant="dark" onClick={onCancel} />
        <Button text="アップロード" variant="filled" onClick={onUpload} />
      </StyledFooter>
    </StyledBackground>
  );
};

const StyledBackground = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    display: flex;
  }

  display: none;
  padding: 16px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 4px;
  background: ${PRIMARY_LIGHT_GREEN};
`;

const StyledFileUploadContainer = styled.div`
  display: flex;
  padding: 12px 20px 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-radius: 4px;
  background: #ffffff;
`;

const StyledTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 200%;
`;

const StyledFileUploadResult = styled.div`
  display: flex;
  margin-top: 6px;
  padding: 10px 0 4px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-top: 1px solid #cccccc;
`;

const StyledFileUploadResultDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
`;

const StyledResultDetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  gap: 24px;
`;

const StyledResultTitle = styled.div`
  min-width: 100px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

const StyledResultValue = styled.div`
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

const StyledFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
